import React from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {Link} from 'react-router-dom';
import _HomeBanner from './_HomeBanner.scss';
import {CategoryMenu} from 'components/category';
import {HighlightNeedOfferTab, TopBusinessTab, TopProductTab} from 'components/home/sub-view';
import ReactDOM from 'react-dom';
import Slider from 'slider';
import {HomeBanners} from 'base/api';
import {connect} from 'react-redux';
import CONFIG from 'base/constants/config';
import { exists } from 'fs';

class HomeBanner extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.loadHomeBannersFromServer = this.loadHomeBannersFromServer.bind(this);

    this.state = {
      isOpened: false,
      data: [],
      appIsMounted: false,
      isLoading: false
    };
  }

  componentDidMount() {
    this.setState({
      appIsMounted: true
    });
    this.loadHomeBannersFromServer();
  }

  loadHomeBannersFromServer() {
    this.setState({isLoading: true}, () => {
      HomeBanners.actions.list.request().then(res => {
        this.postLoadHomeBanners(res.data);
      });
    });
  }

  postLoadHomeBanners(homeBanners) {
    this.props.dispatch({
      type: 'UPDATE_HOME_BANNERS_LIST',
      homeBanners: homeBanners
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.listHomeBanners !== this.state.data) {
      this.setState({isLoading: true}, () => {
        this.setState({data: nextProps.listHomeBanners}, () => {
          this.setState({isLoading: false});
        });
      });
    }
  }

  handleClickTab(e) {
    if (!this.state.isOpened) {
      document.addEventListener('click', this.handleOutsideClick.bind(this), false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick.bind(this), false);
    }

    this.setState({
      isOpened: !this.state.isOpened
    });
  }

  closeOption(){
    this.setState({
      isOpened: false
    });
  }

  handleOutsideClick(e) {
    if (this.node && this.node.contains(e.target)) {
      return;
    } else if (this.node && !this.node.contains(e.target)){
      this.closeOption();
    }
  }

  render() {
    const settings = {
      className: 'slider slick-custom home-slick',
      dots: true,
      infinite: true,
      centerMode: false,
      speed: 1000,
      autoplaySpeed: 4000,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      pauseOnHover: false
    };
    return (
      <div className='home-tab-list'>
        <div className='center'>
          <div className='wrap-category-menu'>
            <CategoryMenu/>
          </div>
        </div>
        <div className='center'>
          <div className='row'>
            <div className='home-tab-panel-wrap'>
              <Slider {...settings}>
                {
                  this.state.data.map((item,i) => {
                    return(
                      <div key={i} style={{backgroundImage: `Url(${this.props.host}${this.props.uriBanner}${item.image})`}}>
                        <img src={`${this.props.host}${this.props.uriBanner}${item.image}`} className='image-slide-responsive' />
                      </div>
                    )
                  })
                }
              </Slider>
            </div>
          </div>  
        </div>
      </div>
    );
  }
}

HomeBanner.defaultProps = {
  host: CONFIG.ENV === 'development' ? CONFIG.UploadImageURLDevelopment : CONFIG.UploadImageURL,
  uriBanner: CONFIG.ENV === 'development' ? '/home-banners/download/' : '/resize/1665x680/home-banners/download/'
}

const bindStateToProps = state => ({
  listHomeBanners: state.listHomeBanners
});

export default connect(bindStateToProps)(HomeBanner);



// WEBPACK FOOTER //
// ./components/home/sub-view/HomeBanner.jsx